interface ProgressBarProps {
  value: number; // 0..100
  ariaLabel?: string;
}

export function ProgressBar({ value, ariaLabel }: ProgressBarProps) {
  const pct = Math.max(0, Math.min(100, value));
  return (
    <div
      className="progress-track"
      role="progressbar"
      aria-valuenow={pct}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-label={ariaLabel}
    >
      <div className="progress-fill" style={{ width: `${pct}%` }} />
    </div>
  );
}
